import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { NAV_LINKS, BRAND } from "@/site";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#050505] border-t border-white/10 mt-24"
    >
      <div className="hazard-stripes h-2" />
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="mb-6">
              <img
                src="/images/clb-logo.jpeg"
                alt="CLB Solution LLC — Coach · Learn · Build"
                className="h-24 md:h-28 w-auto object-contain"
              />
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-md">
              Building safer school bus drivers through training, coaching, and accountability.
            </p>
            <div className="mt-6 space-y-2 text-sm">
              <a
                data-testid="footer-email"
                href={`mailto:${BRAND.email}`}
                className="flex items-center gap-2 text-white/70 hover:text-[#FFCC00] transition-colors"
              >
                <Mail size={16} /> {BRAND.email}
              </a>
              <div className="flex items-center gap-2 text-white/70">
                <MapPin size={16} /> {BRAND.location}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid grid-cols-2 md:grid-cols-3 gap-8">
            <FooterCol title="Explore" links={NAV_LINKS.slice(0, 5)} />
            <FooterCol title="Training" links={NAV_LINKS.slice(5, 10)} />
            <FooterCol title="Resources" links={NAV_LINKS.slice(10)} />
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 text-xs text-white/40 space-y-3">
          <p>
            CLB Solution LLC is an independent business and is not affiliated with any employer, school
            district, state agency, testing agency, or transportation department unless a formal
            agreement is established.
          </p>
          <p>
            © {new Date().getFullYear()} CLB Solution LLC. All rights reserved. {BRAND.status}
          </p>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <div className="text-[11px] uppercase tracking-[0.22em] text-[#FFCC00] mb-4 font-semibold">
        {title}
      </div>
      <ul className="space-y-2">
        {links.map((l) => (
          <li key={l.to}>
            <Link
              to={l.to}
              data-testid={`footer-link-${l.to === "/" ? "home" : l.to.replace(/\//g, "")}`}
              className="text-sm text-white/70 hover:text-white transition-colors"
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
